import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import AtomButton, {atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'

export const PanelFinancingCta = ({buttonText = '', handleOnClick, isDisabled = false}) => {
  return (
    <div className="mt-PanelFinancing-cta">
      <AtomButton
        disabled={isDisabled}
        fullWidth
        onClick={handleOnClick}
        shape={atomButtonShapes.CIRCULAR}
        size={atomButtonSizes.MEDIUM}
      >
        {buttonText}
      </AtomButton>
    </div>
  )
}

PanelFinancingCta.propTypes = {
  buttonText: PropTypes.string,
  handleOnClick: PropTypes.func,
  isDisabled: PropTypes.bool
}
